export const formatMetric = (value) => new Intl.NumberFormat("en-IN").format(Number(value) || 0);

export const safeRate = (numerator, denominator) => {
  const top = Number(numerator) || 0;
  const bottom = Number(denominator) || 0;
  return bottom > 0 ? Math.round((top / bottom) * 100) : 0;
};

export const campaignCanLaunch = ({ connectionLive, approvedTemplate, audience, confirmed }) =>
  Boolean(connectionLive && approvedTemplate && Number(audience) > 0 && confirmed);

